var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.5,
    height: 39.864,
    viewBox: "0 0 43.5 39.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10110",
    "data-name": "Grupo 10110",
    transform: "translate(-675.25 -466.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9175",
    "data-name": "Trazado 9175",
    d: "M711.545,504.364H682.455A5.454,5.454,0,0,1,677,498.909V468h29.091v30.909",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9176",
    "data-name": "Trazado 9176",
    d: "M693,494a5.455,5.455,0,1,0,10.909,0V474H693",
    transform: "translate(13.091 4.909)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_7710",
    "data-name": "Rect\\xE1ngulo 7710",
    width: 14,
    height: 6,
    transform: "translate(685 476)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_51",
    "data-name": "L\\xEDnea 51",
    x2: 14,
    transform: "translate(685 490)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_52",
    "data-name": "L\\xEDnea 52",
    x2: 14,
    transform: "translate(685 498)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest);
export default __webpack_public_path__ + "static/media/test.26bdf5ee.svg";
export { ForwardRef as ReactComponent };